<template>
  <div v-if="item.labels && item.labels.length">
    <div class="d-flex flex-wrap justify-content-left">
      <div v-for="label in sortedLabels" :key="label.id">
        <div
          class="mr-2 mb-1 d-flex justify-content-between align-items-center"
          :class="{ 'bi-label': !isEditable }"
          :style="{
            'background-color': label.color,
            color: 'white',
            padding: '1px 3px',
            'border-radius': '3px',
          }"
          @click="selectLabel(label, $event)"
        >
          <i v-if="label.icon" :class="label.icon" class="mr-1 ml-1"></i>
          {{ label.title }}
          <div v-if="isEditable">
            <i class="pr-1 ml-2 fas fa-times cursor-pointer" @click="removeLabel(label.id)"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import { Prop } from 'vue-property-decorator';
  import { IBoardItemDto } from '@/apiclient/apiclient_generated';
  import { LabelModule, LabelStore } from '@/store/label';
  import lodash from 'lodash';

  @Component
  export default class BoardItemLabels extends Vue {
    private labelStore: LabelModule = LabelStore;

    @Prop() item: IBoardItemDto;
    @Prop() isEditable: boolean;
    @Prop() isSelectable: boolean;

    get sortedLabels() {
      return lodash.sortBy(this.item.labels, ['category', 'title']);
    }

    async removeLabel(labelId) {
      await this.labelStore.removeLabel({
        boardItemId: this.item.id,
        labelId,
      });
    }

    async selectLabel(label, event) {
      if (this.isSelectable && event) {
        event.stopPropagation();

        this.$root.$emit('boardItem::labelSelected', label);
      }
    }
  }
</script>

<style scoped lang="scss">
  .bi-label:hover {
    text-decoration: underline;
  }
</style>
